import { useAtomValue, useSetAtom } from 'jotai';
import { DatasourceUpgradeOverviewDialog } from '../../upgrade/overviewDialog/DatasourceUpgradeOverviewDialog';
import { dataSourceUpgradeDialogAtom } from '@/atoms/dataSources/dataSourcesAtoms';
import { DatasourceUpgradeProvider } from '@/contexts/DatasourceUpgradeContext';
import { usePresetUpgrade } from '@/hooks/components/usePresetUpgrade';

export type DatasourceUpgradeDialogProps = {
  name: string;
  upgradePresetVersion: string | null;
};

export const DatasourceUpgradeDialogContent = ({
  name,
  upgradePresetVersion,
}: DatasourceUpgradeDialogProps) => {
  const setUpgradeState = useSetAtom(dataSourceUpgradeDialogAtom);

  const {
    preset,
    upgradePreset,
    isPresetPending,
    isUpgradePresetPending,
    datasource,
  } = usePresetUpgrade({
    name,
    upgradePresetVersion,
  });

  if (
    (isPresetPending && datasource.spec.usePreset) ||
    (isUpgradePresetPending && upgradePresetVersion)
  ) {
    return null;
  }

  if (!preset || !upgradePreset) {
    throw new Error('Error loading upgrade preset');
  }

  return (
    <DatasourceUpgradeProvider
      currentPreset={preset}
      upgradePreset={upgradePreset}
      datasource={datasource}
      data-testid={`upgrade-datasource-provider-${name}`}
    >
      <DatasourceUpgradeOverviewDialog
        isOpen={true}
        onClose={() => setUpgradeState(null)}
      />
    </DatasourceUpgradeProvider>
  );
};

export const DatasourceUpgradeDialog = () => {
  const upgradeState = useAtomValue(dataSourceUpgradeDialogAtom);

  if (!upgradeState) {
    return null;
  }

  return (
    <DatasourceUpgradeDialogContent
      name={upgradeState.dataSourceName}
      upgradePresetVersion={upgradeState.upgradePresetVersion}
    />
  );
};
